import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { IELTFinancialData } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import {
  IEltDocFormData,
  IELTFormData,
  ISoldProductData,
  TEltFormData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getBusinessPerformanceData } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/businessPerformance/getBusinessPerformanceData'
import { getCompanyPerformanceInitialValues } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/docInitialValues/getCompanyPerformanceInitialValues'
import { getEmptyMultiInputsRow } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getEmptyMultiInputsRow'
import { isDocType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/isDocType'
import { separateFinancialData } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/separateFinancialData'
import { getCompetitorsInitialData } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/financialSnapshot/competitors/getCompetitorsInitialData'
import { getHpSobInitialData } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/financialSnapshot/hpSob/helpers/getHpSobInitialData'
import { getLongPrioritiesInitialData } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/meetingReview/longTermPriorities/helpers/getLongPrioritiesInitialData'
import { getShortPrioritiesInitialData } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/meetingReview/shortTermPriorities/helpers/getShortPrioritiesInitialData'
import { getRevenueInitialData } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/revenue/helpers/getRevenueInitialData'

import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { getCustomerRevenueInitialData } from './docInitialValues/getCustomerRevenueInitialData'

interface IGetForceUpdatedDataFotDifferentEltType {
  formData: TEltFormData
  financialData: IELTFinancialData | null
  eltType: EltType
  soldProducts: ISoldProductData
  populatedMarkets: string
  fYear: number
  fQuarter: number
  partnerId: string
  actualValueTypes: ActualsValueTypes[]
}
export const getForceUpdatedDataFotDifferentEltType = async ({
  formData,
  financialData,
  eltType = EltType.Pptx,
  soldProducts,
  populatedMarkets,
  fYear,
  fQuarter,
  partnerId,
  actualValueTypes,
}: IGetForceUpdatedDataFotDifferentEltType) => {
  const { revenueSnapshots, competitorsSnapshots } = separateFinancialData(financialData, eltType)

  if (isDocType(eltType)) {
    const docData = formData as IEltDocFormData

    const businessPerfData = docData.IsBusinessPerformanceTabEnabled
      ? await getBusinessPerformanceData({
          fQuarter: fQuarter,
          fYear: fYear,
          partnerId,
        })
      : undefined

    const customerRevenueData = getCustomerRevenueInitialData(
      financialData?.CustomerRevenue || [],
      actualValueTypes
    )
    return {
      ...formData,
      CustomerRevenue: customerRevenueData,
      CompetitiveLandscape: getCompetitorsInitialData(competitorsSnapshots, eltType),
      CompanyPerformance: getCompanyPerformanceInitialValues(
        financialData?.CompanyPerformance || []
      ),
      ...(docData.IsBusinessPerformanceTabEnabled &&
        businessPerfData && {
          BusinessPerformanceData: businessPerfData,
        }),
    }
  }
  const pptxData = formData as IELTFormData
  return {
    ...formData,
    LongTermPriorities: getLongPrioritiesInitialData(financialData) || getEmptyMultiInputsRow(),
    ShortTermPriorities: getShortPrioritiesInitialData(financialData) || getEmptyMultiInputsRow(),
    CompetitiveLandscape: getCompetitorsInitialData(competitorsSnapshots, eltType),
    HPSob: getHpSobInitialData(financialData?.HPSob),
    SoldProductData: soldProducts || pptxData.SoldProductData,
    Revenue: getRevenueInitialData(
      revenueSnapshots,
      populatedMarkets.split(';') || [],
      actualValueTypes
    ),
    AdditionalSections: { RevenuePoly: financialData?.HasRevenuePolyData ?? 0 },
    PLC: financialData?.PLC || [],
    PLCParams: financialData?.PLCParams || null,
  }
}
